export default {
      id: "download-cloud-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#download-cloud",
      toString: function () {
        return this.url;
      }
    }